import {
  CardElement,
  Elements,
  ElementsConsumer,
} from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import Config from "config"
import firebase from "firebase"
import React, { useState } from "react"
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  Row,
  Input,
  ListGroup,
  ListGroupItem,
  ListGroupItemText,
} from "reactstrap"
const stripePromise = loadStripe(Config.Stripe.PublicKey)

const StripeCardElementStyle = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: "Arial, sans-serif",
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#32325d",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
}

export default function CardSettings({ auth, stripeCustomer, paymentMethods }) {
  const [state, setState] = useState({
    error: null,
    customerData: {},
    paymentMethod: null,
    value: 0,
    activeTab: "1",
    loading: false,
  })
  function zeroDecimalCurrency(amount, currency) {
    let numberFormat = new Intl.NumberFormat(["en-US"], {
      style: "currency",
      currency: currency,
      currencyDisplay: "symbol",
    })
    const parts = numberFormat.formatToParts(amount)
    let zeroDecimalCurrency = true
    for (let part of parts) {
      if (part.type === "decimal") {
        zeroDecimalCurrency = false
      }
    }
    return zeroDecimalCurrency
  }
  function formatAmountForStripe(amount, currency) {
    return zeroDecimalCurrency(amount, currency)
      ? amount
      : Math.round(amount * 100)
  }
  function enableBtns() {
    document.getElementById("save-btn").disabled = false
    document.getElementById("save-btn").style.backgroundColor = "#6772e5"
    document.getElementById("save-btn").style.cursor = "pointer"
  }
  function disableBtns() {
    document.getElementById("save-btn").disabled = true
    document.getElementById("save-btn").style.backgroundColor = "lightGray"
    document.getElementById("save-btn").style.cursor = "not-allowed"
  }
  const handleSubmit = async (event, stripe, elements) => {
    event.preventDefault()
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make  sure to disable form submission until Stripe.js has loaded.
      return
    }
    disableBtns()
    const result = await stripe.confirmCardSetup(stripeCustomer.setup_secret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name: "Getnet FULL NO",
        },
      },
    })
    if (result.error) {
      enableBtns()
      console.log("PAYMENT SAVING ERROR", result.error)
      // Display result.error.message in your UI.
    } else {
      console.log("[SENDING....]")
      // The setup has succeeded. Display a success message and send
      // result.setupIntent.payment_method to your server to save the
      // card to a Customer
      await firebase
        .firestore()
        .collection("stripe_customers")
        .doc(auth.uid)
        .collection("payment_methods")
        .add({ id: result.setupIntent.payment_method })
      enableBtns()
    }
  }
  const handlePaymentChange = async (event) =>
    setState({ error: event.error ? event.error.message : null })

  return (
    <Elements stripe={stripePromise}>
      <ElementsConsumer>
        {({ elements, stripe }) => (
          <>
            <h2 className="mb-2">Payment Methods</h2>
            <Form onSubmit={(event) => handleSubmit(event, stripe, elements)}>
              <Row form className="mb-3">
                <Col md="12">
                  <CardElement
                    style={{
                      display: "inline-block",
                      width: "100px",
                    }}
                    id="card-element"
                    options={StripeCardElementStyle}
                    onChange={handlePaymentChange}
                  />
                </Col>
                <Col col="12">
                  <Button id="save-btn" type="submit" color="primary">
                    Save new Card
                  </Button>
                </Col>
                <Col md="12">
                  {state?.error && (
                    <div className="card-error" role="alert">
                      {state.error}
                    </div>
                  )}
                </Col>
              </Row>
            </Form>
            <Row>
              <h4 style={{ padding: "0 15px" }}>Saved Cards</h4>
              <Col md="12">
                <ListGroup>
                  {paymentMethods.map((paymentMethod) => (
                    <ListGroupItem
                      className="justify-content-between"
                      key={paymentMethod?.id}
                    >
                      <ListGroupItemText style={{ margin: 0 }}>
                        {`${paymentMethod.card.brand} Card Ending with ${paymentMethod.card.last4} | Expires ${paymentMethod.card.exp_month}/${paymentMethod.card.exp_year}`}
                      </ListGroupItemText>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </Col>
            </Row>
          </>
        )}
      </ElementsConsumer>
    </Elements>
  )
}
